import { render } from "./ProductCategoryGridShimmer.vue?vue&type=template&id=ba0395e2"
import script from "./ProductCategoryGridShimmer.vue?vue&type=script&lang=js"
export * from "./ProductCategoryGridShimmer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__